import { z } from 'zod';
import { Ownership, Sentiment, TimestampLike } from './common.js';

/**
 * What we have learned about a DOMAIN, globally, across every client.
 *
 * Strict on purpose. This collection is shared by all clients, so it may only
 * ever hold facts that are true of the domain itself. Per-subject judgements —
 * `isSubject`, `notes` — must never be written here: whether a facebook.com
 * profile is the right person is a fact about one subject, and learning it
 * globally would pre-fill the wrong answer for the next client on that domain.
 *
 * `.strict()` makes that a parse error rather than a code-review question.
 */
export const DomainClassificationDoc = z
  .object({
    domain: z.string().min(1),
    defaultOwnership: Ownership.optional(),
    defaultSentiment: Sentiment.optional(),
    timesSeen: z.number().int().min(0).default(0),
    lastUpdatedBy: z.string().min(1),
    lastUpdatedAt: TimestampLike,
  })
  .strict();
export type DomainClassificationDoc = z.infer<typeof DomainClassificationDoc>;
